// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"a20a8aaf","623":"ab742652"}[chunkId] + ".chunk.js";
};